import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import { SET_SEARCH_PARAMS } from '../../../reducers';
import queryStringOption from '../headers/queryStringOption';

// Older builds saved identifiers without their array index (TC3-17762), which crashes the identifiers filter on restore.
const isRestorable = (search) => {
  const { identifiers } = qs.parse(search, queryStringOption);
  return identifiers === undefined || Array.isArray(identifiers);
};

const withPersistedParameters = (component) => (props) => {
  const location = useLocation();
  const { push } = useHistory();
  const persistedParams = useSelector((state) =>
    [state.dataGrid.searchParams[location.pathname], state.userSettings.searchParams[location.pathname]].find((params) => params && isRestorable(params))
  );

  const dispatch = useDispatch();

  const setSearchParams = useCallback(
    (payload) => {
      push({ ...location, search: payload });
      dispatch({ type: SET_SEARCH_PARAMS, payload: { pathname: location.pathname, search: payload } });
    },
    [dispatch, push, location]
  );

  useEffect(() => {
    if (!location.search && persistedParams) {
      push({ ...location, search: persistedParams });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchParams = new URLSearchParams(location.search || persistedParams);
  return React.createElement(component, { ...props, setSearchParams: setSearchParams, searchParams: searchParams });
};

export default withPersistedParameters;
